export default "__VITE_ASSET__5f36418a__"